// Tenant-scoped layout for /admin/scenarios* (platform-admin surface).
//
// The scenarios backend (`internal/api/scenarios_handler.go`) requires a
// `?tenant_public_id=<uuid>` query parameter for platform-scope callers.
// Without it the API returns 400 {"error":"tenant_required"}.
//
// This layout wraps the existing /admin/scenarios route subtree with:
//   1. <TenantSelectorBand> — the tenant switcher header band (inline variant).
//   2. <Outlet>             — renders the matched child route.
//
// The router places this element *inside* the existing RequirePlatformAdminRoute
// group so the permission gate is already enforced before this renders.
//
// Phase 3 (tenant-view switcher): PlatformTenantProvider is now promoted to the
// AppShell level (wraps ALL authenticated routes). This layout no longer creates
// its own nested provider — it reads from the outer provider via usePlatformTenant().
// This prevents the double-provider inconsistency where inner-provider useEffect on
// mount would race the outer-provider, briefly writing null to the store.
//
// Security: tenant scoping is UI convenience only. The backend validates
// `tenant_public_id` against the caller's JWT on every request.
import { Outlet } from 'react-router-dom'
import { TenantSelectorBand } from '@/features/platform/components/TenantSelectorBand'

export function AdminScenariosLayout() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <TenantSelectorBand />
      <div className="flex-1 overflow-auto p-6">
        <Outlet />
      </div>
    </div>
  )
}
